// English strings for SERVICES-001 Import Marketplace (owner, 2026-10-23): the vendor admin page and
// the owner console section. Spread into `en` as `en.importMarket`, so keys read
// `t("importMarket.…")`. Copy rules: DESIGN_SYSTEM §9.6.
export const importMarketStrings = {
  title: "Product Import",
  lead: "Wholesale stock from India and China, brought to Nepal by Adyvance.",
  hero: {
    request: "Request a product",
    steps: {
      pick: "Order or make an offer",
      deposit: "Pay the deposit",
      ship: "Adyvance buys and ships",
      rest: "Pay the rest on arrival",
    },
  },
  tabs: {
    marketplace: "Marketplace",
    india: "India",
    china: "China",
    custom: "Custom",
    mine: "My orders",
    orders: "Orders",
    offers: "Offers",
  },
  guide: {
    kicker: "Import from {country}",
    title: "Buy from {site}, delivered by Adyvance",
    lead: "Find any product on {site}. Adyvance checks the supplier, imports it and brings it to your door in Nepal.",
    open: "Open {site}",
    download: "Download the extension",
    installed: "Extension installed · v{version}",
    notInstalled: "Extension not installed",
    how: "How it works",
    s1: "Install the extension",
    s1b: "Once, on this computer.",
    s2: "Find a product on {site}",
    s2b: "It opens in a new browser tab.",
    s3: "Click the Adyvance button",
    s3b: "Bottom right of the product page, then Order.",
    s4: "Place your order here",
    s4b: "Add your mobile, quantity and notes. Adyvance sends you a quote.",
    installTitle: "Install the Adyvance extension",
    installLead: "For Google Chrome and Microsoft Edge. Takes a minute.",
    i1: "Download the extension and unzip it.",
    i2: "Open chrome://extensions in Chrome (or edge://extensions in Edge).",
    i3: "Turn on Developer mode (top right).",
    i4: "Click Load unpacked and choose the unzipped adyvance-import-helper folder (the one with manifest.json inside).",
    i5: "Come back here: it shows Extension installed.",
    reinstall: "Install steps",
    yours: "Your {site} orders",
    yoursEmpty: "Orders you place from {site} show here, with Adyvance's quote.",
    trust1: "Supplier checked by Adyvance",
    trust2: "Pay a deposit, the rest on arrival",
    trust3: "Customs and delivery handled",
  },

  helper: {
    city: "Supplier location: {city}",
    signIn: "Sign in to finish your import order. You'll go straight back to it.",
  },
  order2: {
    from: "From {site}",
    title: "Review and place your order",
    lead: "Adyvance checks this product with the supplier and sends you a price.",
    cancel: "Cancel",
    price: "Price on {site}",
    supplier: "Supplier",
    city: "Location",
    view: "View on {site}",
    you: "Your order",
    phone: "Mobile number",
    phoneHint: "98XXXXXXXX",
    phoneHelp: "Adyvance calls or messages you on this number about this order.",
    phoneBad: "Enter a valid mobile number.",
    qty: "Quantity",
    notes: "Notes",
    notesHint: "Size, colour, packaging, logo, delivery date…",
    add: "Add",
    chips: {
      size: "Size: ",
      colour: "Colour: ",
      packaging: "Packaging: ",
      logo: "Logo printing: ",
      date: "Needed by: ",
    },
    next: "What happens next",
    n1: "Adyvance checks the product and supplier",
    n2: "You get a quote: price, deposit and delivery days",
    n3: "Accept it, pay the deposit, and Adyvance imports it",
    place: "Place order",
    yourPrice: "Your price",
    head: "Order from {site}",
    secProduct: "Product",
    secYou: "Your details",
    checked: "Adyvance checks it with the supplier",
    payNow: "nothing to pay now",
    quoted: "To be quoted",
    payLater: "Nothing to pay now. Deposit only after you accept the quote.",
    sent: "Order sent to Adyvance. You'll see the quote in Custom requests.",
    failed: "The order wasn't sent",
    code: "Code: {code} · Request ID: {id}",
  },

  custom: { yours: "Your custom requests" },
  origin: { all: "All", IN: "India", CN: "China", any: "India or China" },
  filters: {
    search: "Search products",
    allCategories: "All categories",
    all: "All",
    clear: "Clear search",
    sort: "Sort",
    newest: "Newest",
    priceLow: "Lowest price",
    priceHigh: "Highest price",
    moqLow: "Smallest minimum",
    count: "{count} products",
    countOne: "1 product",
  },
  card: {
    perUnit: "/ {unit}",
    tier: "{price} at {qty}+",
    moq: "Min {qty}",
    days: "{min}–{max} days",
    ready: "{qty} ready",
    toOrder: "Bought to order",
    negotiable: "Negotiable",
    fixed: "Fixed price",
    onRequest: "Price on request",
    view: "View details",
  },
  empty: {
    catalogue: "No products match",
    catalogueBody: "Try another search, or request the product you need.",
    orders: "No import orders yet",
    ordersBody: "Orders you place from the catalogue show here.",
    offers: "No offers yet",
    offersBody: "On a product with a negotiable price, choose Make an offer.",
    requests: "No custom requests yet",
    requestsBody: "Send a photo of any product and Adyvance finds it and quotes a price.",
  },
  product: {
    close: "Close",
    ask: "Ask for a price",
    askNote:
      "Send the quantity and the price you want to pay. Adyvance replies with its price, then you order.",
    bulk: "Bulk prices",
    qtyCol: "Quantity",
    priceCol: "Price per {unit}",
    from: "{qty}+",
    lead: "Delivery to Nepal",
    leadDays: "{min} to {max} days",
    deposit: "Deposit",
    depositPct: "{pct}% now, the rest on arrival",
    stock: "Available",
    qty: "Quantity",
    total: "Total",
    depositNow: "Deposit now",
    onArrival: "On arrival",
    order: "Order now",
    offer: "Make an offer",
    belowMoq: "Order at least {qty}.",
    overStock: "Only {qty} available.",
    fixedNote: "This price is fixed.",
    save: "You save {amount}",
    unitPrice: "{price} each",
  },
  checkout: {
    title: "Where should Adyvance deliver?",
    name: "Contact name",
    phone: "Phone",
    address: "Address",
    district: "District",
    note: "Note for Adyvance (optional)",
    place: "Place order",
    placed: "Order {number} placed. Pay the deposit to confirm it.",
    back: "Back",
    missing: "Add a name, phone and address.",
  },
  offer: {
    title: "Make an offer",
    yourPrice: "Your price per {unit}",
    listed: "Listed at {price}",
    note: "Message (optional)",
    send: "Send offer",
    sent: "Offer sent. Adyvance answers here, in Offers.",
    total: "Offer total",
    tooHigh: "Offer less than the listed price.",
  },
  offers: {
    waiting: "Waiting for Adyvance",
    countered: "Adyvance offers {price}",
    accepted: "Accepted at {price}",
    orderBy: "Order by {date}",
    declined: "Not accepted",
    withdrawn: "Withdrawn",
    ordered: "Ordered",
    expired: "Expired",
    yours: "{qty} × {price}",
    accept: "Accept",
    counter: "Counter",
    withdraw: "Withdraw",
    orderNow: "Order now",
    history: "History",
    counterTitle: "Your counter-offer",
    acceptedToast: "Offer accepted. You can order it now.",
    counterToast: "Counter-offer sent.",
    withdrawnToast: "Offer withdrawn.",
  },
  rounds: {
    you: "You",
    adyvance: "Adyvance",
    offer: "{who} offered {qty} × {price}",
    counter: "{who} countered with {qty} × {price}",
    accept: "{who} accepted",
    decline: "{who} declined",
    withdraw: "{who} withdrew",
    asked: "{who} asked for {qty}",
    quoted: "{who} quoted {price} each",
    ask: "{who} asked for a better price",
    cancel: "{who} cancelled",
  },
  state: {
    awaiting_deposit: "Deposit due",
    confirmed: "Confirmed",
    ordered: "Ordered from supplier",
    shipped: "On the way",
    customs: "At customs",
    arrived: "Arrived in Nepal",
    delivered: "Delivered",
    cancelled: "Cancelled",
  },
  stage: {
    awaiting_deposit: "Placed",
    confirmed: "Confirmed",
    ordered: "Ordered",
    shipped: "Shipped",
    customs: "Customs",
    arrived: "Arrived",
    delivered: "Delivered",
  },
  timeline: {
    placed: "Order placed",
    confirmed: "Order confirmed",
    payment_confirmed: "Payment of {amount} confirmed",
    ordered: "Ordered from the supplier",
    shipped: "Shipped to Nepal",
    customs: "At customs",
    arrived: "Arrived in Nepal",
    delivered: "Delivered",
    cancelled: "Cancelled",
  },
  pay: {
    depositDue: "Deposit {amount} due",
    checking: "Payment being checked",
    balanceLater: "{amount} on arrival",
    balanceDue: "{amount} due now",
    paid: "Paid in full",
    title: "Pay this order",
    howWallet:
      "Paid from your Adyvance Wallet and confirmed at once. Short of money? Top up first.",
    paidWallet: "Paid from your wallet",
    how: "Pay Adyvance by bank, eSewa, Khalti or Fonepay, then add the receipt here. Ask Adyvance support for the payment details.",
    method: "Paid by",
    methods: {
      wallet: "Adyvance Wallet",
      bank: "Bank transfer",
      esewa: "eSewa",
      khalti: "Khalti",
      fonepay: "Fonepay",
      cash: "Cash",
      other: "Other",
    },
    amount: "Amount",
    reference: "Transaction ID",
    proof: "Receipt or screenshot",
    addProof: "Add receipt",
    replace: "Replace",
    submit: "Send for checking",
    sent: "Payment sent. Adyvance checks it and confirms here.",
    needProof: "Add the receipt or the transaction ID.",
    tooMuch: "That is more than is left to pay.",
    states: { submitted: "Checking", confirmed: "Confirmed", rejected: "Not accepted" },
    stages: { deposit: "Deposit", balance: "Balance" },
    history: "Payments",
    view: "View receipt",
  },
  order: {
    title: "Order {number}",
    items: "Items",
    amounts: "Amounts",
    total: "Total",
    deposit: "Deposit",
    paid: "Paid",
    left: "Left to pay",
    shipTo: "Deliver to",
    tracking: "Tracking",
    eta: "Expected",
    history: "History",
    cancel: "Cancel order",
    cancelTitle: "Cancel order {number}?",
    cancelBody: "Nothing has been paid, so nothing is charged.",
    keep: "Keep order",
    cancelled: "Order cancelled.",
    placedOn: "Placed {date}",
    lineQty: "{qty} {unit} × {price}",
    addToProducts: "Add to my products",
    inProducts: "In your products",
    addHint: "Once the goods reach Nepal, add them to your store in one click.",
    fromOffer: "From your offer",
    fromRequest: "Custom request",
  },
  addProduct: {
    title: "Add to my products",
    lead: "Creates a draft product in this store with the photo and name, and adds {qty} to stock.",
    name: "Product name",
    price: "Your selling price",
    cost: "Cost per item",
    stock: "Stock to add",
    margin: "Margin {pct}%",
    create: "Create product",
    done: "Product created and stock added. Publish it when it's ready.",
    partial: "Product created, but the stock wasn't added. Set it on the product.",
  },
  request: {
    title: "Request a product",
    lead: "Send photos of what you want. Adyvance finds a supplier in India or China and quotes a price.",
    photos: "Photos",
    addPhotos: "Add photos",
    photosHint: "Up to 6 photos, 5 MB each.",
    photosCount: "{count}/6",
    qtyShort: "Qty",
    targetShort: "Target price (optional)",
    photosShort: "Up to 6 · 5 MB",
    s1Short: "Adyvance finds a supplier",
    s2Short: "You get a quote",
    s3Short: "Accept and pay the deposit",
    drop: "Drop photos here or click to add",
    more: "Add",
    main: "Main",
    secProduct: "Product",
    targetEach: "{price} each",
    targetLabel: "Your target",
    s1: "Adyvance finds a supplier for it in India or China",
    s2: "You get a quote: price, deposit and delivery days",
    s3: "Accept it, pay the deposit, and Adyvance imports it",
    remove: "Remove photo",
    name: "Product name",
    details: "Details",
    detailsHint: "Size, colour, material, packaging…",
    qty: "Quantity",
    origin: "Buy from",
    target: "Target price per piece (optional)",
    link: "Reference link (optional)",
    send: "Send request",
    sent: "Request sent. Adyvance quotes a price here.",
    needPhoto: "Add at least one photo.",
    photoError: "That photo couldn't be added. Use a JPEG, PNG or WebP under 5 MB.",
    states: {
      submitted: "Waiting for a quote",
      quoted: "Quote ready",
      accepted: "Accepted",
      declined: "Not available",
      cancelled: "Cancelled",
    },
    quote: "Adyvance's quote",
    quotePrice: "{price} each",
    quoteMeta: "{pct}% deposit · {min}–{max} days · from {origin}",
    yourTarget: "Your target {price}",
    accept: "Accept quote",
    ask: "Ask for a better price",
    askNote: "Message",
    askPrice: "Your target price per piece",
    askSend: "Send",
    cancel: "Cancel request",
    orderNow: "Order now",
    ordered: "Ordered",
    acceptedToast: "Quote accepted. Place the order to confirm it.",
    askedToast: "Sent. Adyvance will look again.",
    cancelledToast: "Request cancelled.",
    openLink: "Open link",
    qtyLine: "{qty} pieces",
  },
  errors: {
    belowMoq: "That is below the minimum quantity.",
    overStock: "There isn't that much in stock any more.",
    changed: "This changed meanwhile. Reload and try again.",
    tooLarge: "Files can be up to 5 MB.",
  },
  console: {
    title: "Product Import",
    lead: "Wholesale orders, price offers and custom requests from vendors.",
    tiles: {
      orders: "Orders in progress",
      payments: "Payments to check",
      offers: "Offers to answer",
      requests: "Requests to quote",
    },
    tabs: {
      orders: "Orders",
      payments: "Payments",
      offers: "Offers",
      requests: "Requests",
      products: "Catalogue",
    },
    vendor: "Vendor",
    empty: "Nothing here yet.",
    all: "All",
    open: "Open",
    done: "Closed",
    products: {
      add: "Add product",
      edit: "Edit product",
      photos: "Photos",
      addPhoto: "Add photo",
      name: "Product name",
      description: "Description",
      category: "Category",
      origin: "Bought in",
      unit: "Unit",
      price: "Price per unit",
      tiers: "Bulk prices",
      addTier: "Add bulk price",
      tierQty: "From quantity",
      tierPrice: "Price",
      moq: "Minimum order",
      negotiable: "Negotiable",
      negotiableOn: "Vendors see a Negotiable tag and can make a price offer.",
      negotiableOff: "Fixed price: vendors order at the listed price.",
      negotiableHidden: "Vendors can still ask for a price, because the price is hidden.",
      vendorsSee: "What vendors see",
      showPrice: "Show price",
      showPriceOn: "Vendors see the price and bulk prices and can order directly.",
      showPriceOff:
        "Vendors see Price on request and ask with their own price. The price is never sent to them.",
      hiddenPill: "Price hidden",
      cover: "Cover",
      makeCover: "Make this the cover photo",
      deposit: "Deposit %",
      leadMin: "Days (from)",
      leadMax: "Days (to)",
      stock: "Available quantity",
      stockHint: "Leave empty when bought to order.",
      state: "Status",
      states: { draft: "Draft", active: "On sale", archived: "Archived" },
      save: "Save",
      saved: "Product saved.",
      needPhoto: "Add at least one photo before putting it on sale.",
    },
    orders: {
      move: "Move to",
      note: "Note for the vendor (optional)",
      tracking: "Tracking number",
      eta: "Expected arrival",
      moved: "Order updated.",
      record: "Record a payment",
      recorded: "Payment recorded.",
      confirm: "Confirm",
      reject: "Reject",
      rejectNote: "Why (the vendor sees this)",
      confirmed: "Payment confirmed.",
      rejected: "Payment rejected.",
      balanceFirst: "Confirm the remaining payment before delivering.",
      lines: "Items",
      payments: "Payments",
      vendorNote: "Vendor's note",
    },
    offers: {
      accept: "Accept",
      counter: "Counter",
      decline: "Decline",
      price: "Your price per unit",
      qty: "Quantity",
      note: "Message (optional)",
      answered: "Answer sent.",
      vendorTurn: "Waiting for the vendor",
      listed: "Listed {price}",
    },
    requests: {
      quote: "Send quote",
      decline: "Not available",
      price: "Price per piece",
      deposit: "Deposit %",
      origin: "Buy from",
      leadMin: "Days (from)",
      leadMax: "Days (to)",
      note: "Message (optional)",
      sent: "Quote sent.",
      declined: "Request declined.",
      target: "Vendor's target {price}",
      noTarget: "No target price",
      from: "From {site}",
      source: "Came from",
      phone: "Vendor's mobile",
      seen: "Price on {site}",
      supplier: "Supplier",
    },
  },
} as const;
